import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { BrowserRouter } from "react-router-dom";
import './assets/common.scss';
import './index.scss';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://0068f57d5a5249e9bef811c1a8163cdd@app.shasteel.cn/sentry/6',
        integrations: [new Integrations.BrowserTracing()],
        tracesSampleRate: 1.0,
    });
}

ReactDOM.render(<BrowserRouter><App /></BrowserRouter>, document.getElementById('root'))